const carRental = {
  carRental: "किराए पर कार लेना", // translated 
  carRentals: "कार का किराया", // translated 
  pickUpPoint: "पिक अप बिंदु", // translated 
  dropOffPoint: "ड्रॉप-ऑफ पॉइंट", // translated 
  pleaseSelectAPickUpPoint: "कृपया पिक-अप पॉइंट चुनें", // translated 
  pickUpDate: "पिक करने की तिथि", // translated 
  dropOffDate: "बाहर निकलने की तिथि", // translated 
  pickUp: "उठाना", // translated 
  dropOff: "बाहर निकलना", // translated 
  edit: "संपादन करना", // translated 
  fuelPolicy: "ईंधन नीति", // translated 
  pickUpLocation: "लेने की जगह", // translated 
  mileage: "लाभ", // translated 
  transmission: "हस्तांतरण", // translated 
  airCondition: "एयर कंडीशनर", // translated 
  minimumAge: "न्यूनतम आयु", // translated 
  maximumAge: "अधिकतम आयु", // translated 
  providerAddress: "प्रदाता का पता", // translated 
  providerPhone: "प्रदाता फ़ोन", // translated 
  driverInfo: "ड्राइवर की जानकारी", // translated 
  driversInfo: "ड्राइवर की जानकारी", // translated 
  differentDropOff: "किसी अन्य स्थान पर छोड़ना", // translated 
  maxPassengers: "अधिकतम यात्री", // translated 
  budget: "बजट", // translated 
  provider: "प्रदाता", // translated 
  carModel: "कार मॉडल", // translated 
  numOfDoors: "दरवाजों की संख्या", // translated 
  fuelType: "ईंधन प्रकार", // translated 
  driverAge: "चालक की आयु", // translated 
  enterValidDriversAge: "कृपया चालक की वैध आयु दर्ज करें।", // translated 
  workingHours: "कार्य के घंटे", // translated 
  driverNationality: "चालक की राष्ट्रीयता", // translated 
  nationalityIsRequired: "राष्ट्रीयता आवश्यक है", // translated 
  carRentalRate: "कार किराये की दर", // translated 
  dueNow: "अभी बकाया है", // translated 
  duePickUp: "पिक-अप के समय देय", // translated 
  toViewOfferPDF:
    "इस प्रस्ताव की सभी किराये की शर्तों वाले पीडीएफ दस्तावेज़ को देखने के लिए, कृपया", // translated 
  toViewTermsAndCondPDF:
    "लागू CARNECT नियम और शर्तें देखने के लिए, कृपया", // translated 
  carRentalsNotFound:
    "हमें कार किराए पर लेने से संबंधित कोई परिणाम नहीं मिला। असुविधा के लिए हमें खेद है।", // translated 
};


export default carRental;
